// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__BjaAg","title":"Error_title__DEBMS","description":"Error_description__LMrWo","content":"Error_content__HANzd","button":"Error_button__ztww1"};